import { render, staticRenderFns } from "./verivikasiPermohonanDarurat.vue?vue&type=template&id=c2f252b2&"
import script from "./verivikasiPermohonanDarurat.vue?vue&type=script&lang=js&"
export * from "./verivikasiPermohonanDarurat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QSeparator,QBtnGroup,QTooltip,QDialog,QImg,QSpinnerIos,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QSeparator,QBtnGroup,QTooltip,QDialog,QImg,QSpinnerIos,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
